import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DeeplinksService {
  deeplink$: BehaviorSubject<string>;
  private deeplinks: Record<string, BehaviorSubject<string>> = {};

  constructor(private apiService: ApiService) {
    this.deeplink$ = this.getDeeplink$('equipment_admin');
  }

  getDeeplink$(appName: string): BehaviorSubject<string> {
    if (!this.deeplinks[appName]) {
      this.deeplinks[appName] = new BehaviorSubject<string>('');
    }
    return this.deeplinks[appName];
  }

  async setDeeplink(appName: string) {
    const subject = this.getDeeplink$(appName);
    try {
      const url = await this.apiService.get(`deeplinks/${appName}`);
      subject.next(url);
      return url;
    } catch (err) {
      console.log(`Could not load ${appName} url.`, err);
      return '';
    }
  }

  async setEquipmentAdminUrl() {
    return this.setDeeplink('equipment_admin');
  }

  async setCustomerAdminUrl() {
    return this.setDeeplink('customer_admin');
  }
}
